import { ExposureDirectionType, LevelType, PositionType } from 'data/types';
import { openingRunWithOpenNeighborOverhang } from 'utils/open-neighbor-opening-runs';
import { plainEdgeRun } from 'utils/opening-layout';
import { EdgeRunType } from 'utils/opening-position-types';
import { spaceOpenNeighborRuns } from 'utils/space-opening-run';
import { OpeningRunSpaceType } from 'utils/space-opening-run-types';
import {
  WallRunBoundsResolverType,
  WallRunType
} from 'utils/space-wall-reconcile-types';

const ABSOLUTE_ORIGIN_FEET: PositionType = { x: 0, y: 0 };

export function wallRunToEdgeRun(run: WallRunType): EdgeRunType {
  return plainEdgeRun(run.cardinal, run.segment.start, run.segment.end, {
    edgeIndex: run.edgeIndex,
    outward: run.segment.outwardNormal
  });
}

export function openNeighborWallRunBounds(
  space: OpeningRunSpaceType,
  level: LevelType | null | undefined,
  homeOrientation: ExposureDirectionType | undefined
): WallRunBoundsResolverType {
  const neighbors = spaceOpenNeighborRuns(space, level, homeOrientation);
  return (run) =>
    openingRunWithOpenNeighborOverhang(
      wallRunToEdgeRun(run),
      ABSOLUTE_ORIGIN_FEET,
      neighbors
    );
}
